export default __webpack_public_path__ + "static/media/photo1.375f27ac.jpg";